export const SUPPORT_EMAIL = 'privacy@kochdavis.com';

export const PROFILE_LOADER_TEXTS = [
  'Creating your new career profile for better job solutions',
  'Reviewing your experience to highlight your top skills',
];

export const DEFAULT_LOADER_TEXTS = ['Retrieving details', 'Retrieving details'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'Nothing found',
  subText:
    'Sorry, but nothing matched your search terms. Please try again with some different keywords',
};

export const STUB_ERROR_TEXTS = {
  mainText: 'Jobs are temporarily unavailable',
  subText: 'Please refresh the page in a minute',
};

export const HISTORY_STUB_TEXTS = {
  mainText: `You haven't opened a job yet`,
  subText: `Your full click history — from our emails and on the board, back to the day you set up your search.`,
};

export const HISTORY_SEARCH_STUB_TEXTS = {
  mainText: 'Nothing found',
  subText: 'Try a different title, company, or location',
};

export const HOMEPAGE_QUESTIONS = [
  {
    title: 'Does any of this cost me anything?',
    text: 'No. Browsing jobs, setting up your search and getting matches is free for job seekers. Employers pay us to fill their roles, you never do.',
  },
  {
    title: 'Do I need an account to look at jobs?',
    text: 'No. Every listing on the board is open to browse without signing up. An account only matters when you want us to rank new openings against your roles, level and cities and write to you when something fits.',
  },
  {
    title: 'Who sees my resume?',
    text: "Nobody, until you apply. Your resume stays in your profile and is only shared with an employer when you apply to one of their roles. We don't sell it or put it in a public database.",
  },
  {
    title: 'How often will you email me?',
    text: 'Only when a new opening matches your search. There is no fixed schedule and no filler, so a quiet week means nothing new landed. Every email has an unsubscribe link and you can turn alerts off at any time.',
  },
  {
    title: 'Why do some jobs show no salary?',
    text: "Because the employer didn't publish one. We show pay exactly as the listing states it and don't guess a number. To get a sense of the range, check what similar roles on the board pay.",
  },
];
